import { useEffect } from 'react';
import { hasLegacyPlan as hasLegacyPlanFlag } from '@gonfalon/constants/constants';
import { noop } from 'lodash';

import {
  fetchLegacySubscription as fetchLegacySubscriptionAction,
  fetchSubscription as fetchModernSubscriptionAction,
} from '#actions/billing';
import { legacySubscriptionSelector, subscriptionSelector } from '#reducers/billing';
import { ready } from '#utils/reduxUtils';

import { useDispatch } from './useDispatch';
import { useSelector } from './useSelector';

export const useSubscription = () => {
  const dispatch = useDispatch();

  const hasLegacyPlan = hasLegacyPlanFlag();
  const legacySubscription = useSelector(legacySubscriptionSelector);
  const modernSubscription = useSelector(subscriptionSelector);

  const subscriptionEntity = hasLegacyPlan ? legacySubscription.get('entity') : modernSubscription.entity;
  const subscriptionRequest = hasLegacyPlan ? legacySubscription : modernSubscription.fetchRequest;

  const isReady = ready(subscriptionRequest);

  useEffect(() => {
    if (isReady) {
      return;
    }

    if (hasLegacyPlan) {
      dispatch(fetchLegacySubscriptionAction())?.catch(noop);
      return;
    }

    dispatch(fetchModernSubscriptionAction())?.catch(noop);
  }, [dispatch, hasLegacyPlan, isReady]);

  return {
    isReady,
    entity: subscriptionEntity,
    hasLegacyPlan,
  };
};
